import { NextRouter, useRouter } from 'next/router';
import { RouterLinks } from 'src/routing/routerLinks';
import { getPath } from './utils';

export function useGetIdFromUrlForKey(key: RouterLinks): string | undefined {
  const router = useRouter();
  router.pathname;
  // const parts = useLocation().pathname.split('/');
  // const routerLinkParts = key.split('/');
  // let location = -1;
  // routerLinkParts.find(part => {
  //   const index = parts.indexOf(part);
  //   if (index > location) {
  //     location = index;
  //     return false;
  //   } else {
  //     location = -1;
  //     return true;
  //   }
  //   return false;
  // });
  // return location >= 0 && location < parts.length - 1
  //   ? parts[location + 1]
  //   : undefined;
  return undefined;
}

export function useAsmRouter() {
  const router = useRouter();
  const { query } = router;
  const isDebugEnabled = query['debug'] === 'true';
  const debugExtras = isDebugEnabled ? '?debug=true' : '';
  return {
    ...router,
    replaceString_UNSAFE: (route: string) => {
      return router.replace(route);
    },
    pushString_UNSAFE: (route: string) => {
      return router.push(route);
    },
    pushFlat: (route: RouterLinks, extra: string[] = []) => {
      return router.push(`/${getPath(route, extra)}${debugExtras}`);
    },
    push: (route: RouterLinks, extra: string[] = []) => {
      return router.push(`${getPath(route, extra)}${debugExtras}}`);
    },
    replace: (route: RouterLinks, extra: string[] = []) => {
      return router.replace(`${getPath(route, extra)}${debugExtras}}`);
    },
    replaceFlat: (route: RouterLinks, extra: string[] = []) => {
      return router.replace(`/${getPath(route, extra)}${debugExtras}`);
    },
    replace_UNSAFE: (input: Parameters<NextRouter['replace']>) => {
      return router.replace(...input);
    },
    push_UNSAFE: (input: Parameters<NextRouter['push']>) => {
      return router.push(...input);
    },
  };
}
